export const DISPLAY_CONSTANTS = {
  APP_NAME: {
    WEB: $localize`Global Scan and Link (GSL)`,
    MOBILE: $localize`GSL`,
  },
};
